// *******************************************************************
// * This file is automatically generated with each and every build, *
// * your edits will vanish and your efforts will be in vain... 🤷   *
// *******************************************************************

module.exports = {
    name: 'design-system',
    version: '2.97.0',
};
